import React from 'react';
import classnames from 'classnames';
import Locale from '@active/react-utils/i18n/Locale';
import Responsive from '@active/react-utils/components/Responsive';
import OrderSummaryContent from './components/OrderSummaryContent';
import OrderSummaryButton from './components/OrderSummaryButton';

const OrderSummary = (props) => {
  const {
    orderSummaryTitle, className, SummaryButtonNode,
  } = props;
  const classes = classnames({
    'order-summary': true,
  }, className);
  return (
    <div className={classes} id="checkout_order_summary">
      <div className="order-summary__title">
        {orderSummaryTitle || <Locale id="checkout.lib.components.orderSummary.yourOrder" />}
      </div>
      <div className="order-summary__content">
        <OrderSummaryContent {...props} />
        <Responsive eqAbove="xl">
          { SummaryButtonNode ? <SummaryButtonNode {...props}/> : <OrderSummaryButton {...props}/>}
        </Responsive>
      </div>
    </div>
  );
};

export default OrderSummary;
